// react
import React, { useState, useContext, useEffect } from "react";

// react-router-dom
import { useParams } from "react-router-dom";

// axios
import axios from "axios";

// styles
import useStyles from "./deviceRegistryStyles";

// context
import { DeviceContext } from "../../Context/deviceContext/deviceContext";

// components
import Navbar from "../../components/navbar/navbarComponent";
import Footer from "../../components/footer/footerComponent";
import ErrorMessage from "../../components/error/errorComponent";
import Activation from "../activation/activationComponent";
import PublicDashboard from "../publicDashboard/publicDashboardComponent";
import Dashboard from "../dashboard/dashboardComponent";

// Registry Component
const Registry = () => {
  // .env variables
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bodyUrl = process.env.REACT_APP_ACTIVATION_MID_URL;

  const classes = useStyles();
  const { devEUI } = useParams();
  const [devicUnavailable, setDeviceUnavailable] = useState(false);
  const { setDeviceData, deviceData } = useContext(DeviceContext);
  const [dataReceived, setDataReceived] = useState(false);
  const [isHealthLoading, setisHealthLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setisHealthLoading(true);
    await axios
      .get(`${baseUrl}/${bodyUrl}${devEUI}`)
      .then((resp) => {
        resp.status == 200
          ? setDeviceData(resp.data)
          : setDeviceUnavailable(true);
        setDataReceived(true);
        setisHealthLoading(false);
      })
      .catch((err) => {
        setDeviceUnavailable(false);
        setisHealthLoading(false);
      });
  };

  return (
    <>
      <div>
        {/* navbar */}
        <Navbar
          title={
            deviceData.is_device_active ? `${deviceData.tenant_name}` : "Fogwing Device Activation"
          }
        />
      </div>
      {dataReceived ? (
        <div>
          {/* page content */}
          {!devicUnavailable && deviceData.is_device_active ? (
            <div className={classes.mainContent}>
              {deviceData.is_public_dashboard ? (
                <PublicDashboard
                  devEUI={devEUI}
                  isHealthLoad={isHealthLoading}
                />
              ) : (
                <Dashboard devEUI={devEUI} isHealthLoad={isHealthLoading} />
              )}
            </div>
          ) : !devicUnavailable &&
            !deviceData.is_device_active &&
            deviceData.tot_act_dev < deviceData.tot_avail_dev ? (
            !devicUnavailable &&
            !deviceData.is_device_active &&
            deviceData.tot_act_dev < deviceData.tot_avail_dev ? (
              <div className={classes.mainContent}>
                <Activation devEUI={devEUI} />
              </div>
            ) : (
              <ErrorMessage
                message={
                  deviceData.tot_act_dev >= deviceData.tot_avail_dev
                    ? "Device Activation cannot be submitted since you have exceed the license limits. Please reach your admin."
                    : "Device Not Found"
                }
              />
            )
          ) : (
            !devicUnavailable &&
            !deviceData.is_device_active &&
            deviceData.tot_avail_dev === 0 && (
              <div className={classes.mainContent}>
                <Activation devEUI={devEUI} />
              </div>
            )
          )}
        </div>
      ) : (
        <div className={classes.progressBar}></div>
      )}
      {/* footer */}
      <Footer />
    </>
  );
};

export default Registry;
